// extracted by mini-css-extract-plugin
module.exports = {"coaches":"styles__coaches___2IIyE","coaches-name-bold":"styles__coaches-name-bold___3fdlv"};